// extracted by css-extract-rspack-plugin
export default {"cls1":"ShareModal-cls1_7UZ","cls2":"ShareModal-cls2_xYO ShareModal-cls1_7UZ"};